import { useState, useEffect, useMemo, useCallback } from "react";
import {
  postDoctors,
  postContentDiag,
  queryContentByDiagId,
  queryTabDoctorList,
} from "api/doctor-list";
import { useParams } from "react-router-dom";

import AegisConfigSdk from '@jdh/aegis-conf-sdk'; //天空之城组件配置sdk
// @ts-ignore
import {TabDoctorList} from '@jdh-laputa/mpass-common-comp/es/codes/comp/tabDoctorList';
// import { useMount } from "hooks/use-lifecycle";
import jdh from "../../asset/img/login/jdh.png";
import logo from "../../asset/img/login/logo.png";
import Prescribible from "../../asset/img/login/Prescribible.png";
import selfSupport from "../../asset/img/login/self-support.png";
import Triple from "../../asset/img/login/Triple-A.png";
import TripleHospital from "../../asset/img/login/Class-A-tertiary-hospital.png";
import icon_right from "../../asset/img/login/icon_right.png";
import icon from "../../asset/img/login/icon.png";
import icon1 from "../../asset/img/login/icon1.png";
import icon2 from "../../asset/img/login/icon2.png";
import img1 from "../../asset/img/login/img1.png";
import img2 from "../../asset/img/login/img2.png";

import Tips from "../../asset/img/login/Tips.png";
import Start from "../../asset/img/login/Start.png";
import end from "../../asset/img/login/end.png";
import QRCode from "qrcode.react";
import { Popover } from "antd";
import styles from "./index.less";
import { onClickhref } from "utils";
import { ErrorComp } from "components/error";
import { getQrCodeListUrl, getQrCodeUrl } from "utils/doctor";
import { getImgUrl } from '@jdhfe/seouifuncs/dist/tools/getImgUrl';
import PatientInfo from "./PatientInfo";

// import { seoFooter } from "utils/seoFooter.js";
const ConsultationRecord = () => {
  const params = useParams<Record<any, any>>();
  const [departData, setDepartData] = useState<any>();
  const [contentDiagData, setContentDiagData] = useState<any>();
  const [contentByDiagIdData, setContentByDiagIdData] = useState<any>();
  const [paragraphId, setParagraphId] = useState<any>();
  const [loading, setLoading] = useState(true);
  const [docNum, setDocNum] = useState();

  const isZhangShi = contentByDiagIdData ? !!contentByDiagIdData?.displayFlag : undefined
  // const hypageFrom = useMemo(() => {
  //   // hypageFrom：0为医生主页进入；1为seo页面进入；3为商详页进入
  //   if (params?.seoRedirectFlag === 'true') {
  //     return '1';
  //   }
  //   return params?.hypageFrom || '1';
  // }, [params]);

  const [floorInfos, setFloorInfo] = useState<any>();
  const getDoctorListConfig = async () => {
    // @ts-ignore
    const confSdk = new AegisConfigSdk({
      env:
        process.env.MODE == 'dev'
        || process.env.MODE == 'test' ? 'pre' : 'pro', // [必填] pre 预发 | pro，线上
      platform: 'H5', // 固定
    });
    // 绑定2.0.1版本
    const fetchPageInfo = confSdk.getPageInit({subassemblyId: 23304});
    let [floorInfo]: any = await Promise.all([fetchPageInfo]);
    console.log(floorInfo, 45454);
    floorInfo.api = {
      ...floorInfo.api,
      getTabDoctorList: queryTabDoctorList
    }
    floorInfo.cfg = {
      ...floorInfo.cfg,
      serviceStyle: 1,
    }
    setFloorInfo(floorInfo) ;
  }
  useEffect(() => {
    if (params.id) {
      const getRuleType = () => {
        // if (hypageFrom === '1') {
        //   return 3;
        // }
        // if (hypageFrom === '3') {
        //   return 4;
        // }
        // return 2;
        return 3;
      };
      queryContentByDiagId({
        diagId: params.id,
        tenantId: 287,
        ruleType: getRuleType()
      }).then((res: any) => {
        setContentByDiagIdData(res);
    
        setParagraphId(res?.contentDiags?.[0]?.receptionDoctorId);
        if (res?.contentDiags?.[0]?.receptionDoctorId) {
          postDoctors({
            doctorId: res?.contentDiags[0]?.receptionDoctorId,
            queryServiceAndTag: true,
          }).then((res: any) => {
            setDepartData(res);
          });

          postContentDiag({
            receptionDoctorId: res?.contentDiags[0]?.receptionDoctorId,
            pageSize: 10,
            tenantId: 287,
          }).then((res: any) => {
            setContentDiagData(res.data);
          });
        }
      }).finally(() => {
        setLoading(false);
      });
      // seoFooter();
    }
    getDoctorListConfig();
  }, []);
  const onClickOpen = (url?: any) => {
    if (url) {
      window.open(url);
    } else {
      window.open("/");
    }
  };

  const qrCodeUrl = getQrCodeUrl(paragraphId);
  const Content = (props: any) => (
    <div className={styles.overbookingCodebotton}>
      <QRCode value={props.qrCodeUrl} size={props?.size || 80} />
      <div>
        <h3>{props.title || '扫码关注医生'}</h3>
        <h6>{props.desc || `关注${departData?.docName}医生，方便随时提问`}</h6>
      </div>
    </div>
  );
  const timeStampFun = (timeStamp: string | number | Date) => {
    const date = new Date(timeStamp);
    const year = date.getFullYear();
    const month = Number(date.getMonth()) + 1;
    const day = date.getDate();
    let hour: any = date.getHours();
    if (hour < 10) {
      hour = "0" + hour;
    }
    let minute: any = date.getMinutes();
    if (minute < 10) {
      minute = "0" + minute;
    }
    return year + "/" + month + "/" + day;
    // return year + "/" + month + "/" + day + " " + hour + ":" + minute;
  };
  let departName1 =
    (contentByDiagIdData && contentByDiagIdData?.contentName) || "";
  let text = contentByDiagIdData?.qaChatMessageDTOS?.find(
    (item: any) => item.messageSource === 1
  )?.messageContent?.content;

  let contentName = departName1 && departName1?.substring(0, 30);
  let contentName1 = departName1 && departName1?.substring(0, 40);
  let contentName2 = departName1 && (departName1 + text)?.substring(0, 100);
  let str1 = contentByDiagIdData?.introduction;
  let str2 = contentByDiagIdData?.suggestion?.replaceAll('<b>', '')?.replaceAll('</b>', '');
  // let str3 = str1 + str2;
  let contentName3 = contentName2 + str1 + str2;
  departData?.secondDepartName || contentName1
    ? (document.title =
        (departData?.secondDepartName || '') +
        "_" +
        (contentName1 || '') +
        "-" +
        "京东健康互联网医院")
    : null;
  contentName2
    ? document
        .querySelector('meta[name="description"]')
        ?.setAttribute("content", contentName3)
    : null;
  departData?.docName
    ? document
        .querySelector('meta[name="keywords"]')
        ?.setAttribute(
          "content",
          departData?.secondDepartName +
            "," +
            departData?.hospitalName +
            departData?.docName +
            "医生"
        )
    : null;

  const PopOver = ({ children, data }: any) => {
    const qrCodeUrl = getQrCodeUrl(data?.doctorInfo?.doctorId);
    return (
      <Popover content={(
        <Content
          qrCodeUrl={qrCodeUrl}
          title="手机扫一扫"
          desc="快速下单"
        />
      )}>
        {children}
      </Popover>
    )
  }

  const PopOvers = ({ children, data }: any) => {
    const qrCodeUrl = getQrCodeListUrl(data?.bottomButtonUrl);
    return (
      <Popover content={(
        <Content
          size={100}
          qrCodeUrl={qrCodeUrl}
          title="手机扫一扫"
          desc="快速下单"
        />
      )}>
        {children}
      </Popover>
    )
  }

  return (
    <div className={styles.consultationRecord}>
      { !loading && !contentByDiagIdData && <ErrorComp /> }
      {/* 描述信息 */}
      {
        !loading && contentByDiagIdData && isZhangShi &&
        <div className={styles.describe}>
          <p>
            当前位置：
            <i
              data-a-href="/"
              onClick={() => {
                (window as any).log(
                  "HealthSEO_Exchange",
                  "Navigation",
                  JSON.stringify({
                    jsonParam: { id: params.id },
                  })
                );
                setTimeout(() => {
                  onClickOpen();
                }, 200);
              }}
            >
              首页
            </i>
            <span>{">"}</span>
            {departData?.hospitalName && departData?.docName ? (
              <>
                <span
                onClick={() => {
                  onClickhref("/hospital/" + departData?.hospitalId);
                }}
                data-a-href={"/hospital/" + departData?.hospitalId}
                >{departData?.hospitalName}</span>
                {departData?.hospitalName && <span>{">"}</span>}
                <span
                data-a-href = {
                  departData?.doctorSource === 1 ? `/yellowdoctor/${paragraphId}` : `/doctor/${paragraphId}`
                }
                onClick={() => {
                  let url = `/doctor/${paragraphId}`;
                  if (departData?.doctorSource === 1) {
                    url = `/yellowdoctor/${paragraphId}`;
                  }
                  onClickOpen(url);
                }}
                >{departData?.docName}</span>
                <span>{">"}</span>
              </>
            ) : null}
          </p>
          {contentName && departData?.secondDepartName && (
            <h1 className={styles.describe1}>
              {departData?.secondDepartName
                ? departData?.secondDepartName + ", "
                : null}
              {contentName}
            </h1>
          )}
        </div>
      }
      {/* 内容 */}
      { !loading && contentByDiagIdData &&
        <div className={styles.content}>
          {/* 左 */}
          <div className={styles.left}>
          {contentByDiagIdData?.introduction ? (
              <div className={styles.caseInfo}>
                <div className={styles.caseInfoTit}>疾病详情</div>
                <div className={styles.caseInfoTitSymptom}>
                  <p
                    className={styles.detailContent}
                    dangerouslySetInnerHTML={{
                      __html: contentByDiagIdData?.introduction,
                    }}
                  ></p>
                </div>
              </div>
            ) : null}
            {contentByDiagIdData?.suggestion ? (
              <div className={styles.caseInfo}>
                <div className={styles.caseInfoTit}>医生建议</div>
                <div className={styles.caseInfoTitSymptom}>
                  <p
                    className={styles.detailContent}
                    dangerouslySetInnerHTML={{
                      __html: contentByDiagIdData?.suggestion,
                    }}
                  ></p>
                </div>
              </div>
            ) : null}

            {/* 医生和患者的交流 */}
            {contentByDiagIdData?.qaChatMessageDTOS?.length > 0 ? (
                <div className={styles.doctorsAndPatients}>
                  <div className={styles.doctorsAndPatientsTit}>
                    {/* {departData?.docName}医生和患者的交流 */}
                    问答详情
                  </div>
                  <div className={styles.doctorsAndPatientsTips}>
                    <img src={Tips} alt="" />
                    <span>问诊中的医患交流仅供参考，不构成任何诊疗建议</span>
                  </div>
                  {/* 问诊开始 */}
                  <div className={styles.doctorsAndPatientsStart}>
                    <img src={Start} alt="" />
                  </div>
                  {/* 交流信息 */}
                  {contentByDiagIdData &&
                    Object.keys(contentByDiagIdData).length > 0 && (
                      <div className={styles.doctorsAndPatientsStartTime}>
                        {contentByDiagIdData?.createTime &&
                          timeStampFun(contentByDiagIdData?.createTime)}
                      </div>
                    )}
                  {contentByDiagIdData?.qaChatMessageDTOS?.map((item: any) => {
                    return (
                      <div key={item.msgId}>
                        <div
                          className={
                            item.messageSource === 2
                              ? styles.doctorsAndPatientsStartDoctor1
                              : styles.doctorsAndPatientsStartDoctor
                          }
                        >
                          <div
                            className={styles.doctorsAndPatientsStartDoctorTit}
                          >
                            {item.messageSource === 1 ? (
                              <>
                                <img
                                  src={getImgUrl(item.userHeadPic)}
                                  // alt={departData?.docName}
                                  alt=""
                                  onClick={() => {
                                    (window as any).log(
                                      "HealthSEO_Exchange",
                                      "DoctorPhotos",
                                      JSON.stringify({
                                        jsonParam: {
                                          id: params.id,
                                          doctorid: paragraphId,
                                        },
                                      })
                                    );
                                    setTimeout(() => {
                                      onClickOpen(
                                        window.location.origin +
                                          "/doctor/" +
                                          paragraphId
                                      );
                                    }, 200);
                                  }}
                                />
                                <span>{item.userSourceName}</span>
                                {/* <span>{isZhangShi ? departData?.titleName : ''}</span> */}
                              </>
                            ) : item.messageSource === 3 ? (
                              <>
                                <img src={getImgUrl(item.userHeadPic)} alt="" />
                                <span>{item.userSourceName}</span>
                              </>
                            ) : null}

                            {item.messageSource === 2 ? (
                              <>
                                <span>{item.userSourceName}</span>
                                <img src={getImgUrl(item.userHeadPic)} alt="" />
                              </>
                            ) : null}
                          </div>
                          {item?.messageContent?.content &&
                            (item.messageDisplayType === 3 ? (
                              <PatientInfo
                                item={item}
                                digInfo={contentByDiagIdData}
                              />
                            ) : (
                              <div
                                className={
                                  styles.doctorsAndPatientsStartDoctorText
                                }
                              >
                                <span>{item?.messageContent?.content}</span>
                              </div>
                            ))}
                        </div>
                      </div>
                    );
                  })}

                  {/* 问诊结束 */}
                  <div className={styles.doctorsAndPatientsEnd}>
                    <img src={end} alt="" />
                  </div>
                </div>
              ) : (!loading && !isZhangShi && !contentByDiagIdData?.introduction ? <ErrorComp tip="很抱歉，内容暂不可见"/> : null)}

            {/* 与医生的问诊记录 */}
            {isZhangShi && contentDiagData && contentDiagData?.length > 0 && (
              <div className={styles.consultationList}>
                <div className={styles.consultationListTit}>
                  相关问诊记录
                  {/* {departData?.docName}医生的问诊记录 */}
                </div>
                <ul>
                  {contentDiagData.map((itme: any, index: any) => {
                    return (
                      <li
                        key={index}
                        onClick={() => {
                          (window as any).log(
                            "HealthSEO_Exchange",
                            "MoreDoctorExchanges",
                            JSON.stringify({
                              jsonParam: { id: params.id, doctorid: paragraphId },
                            })
                          );
                          setTimeout(() => {
                            window.open(
                              window.location.origin +
                                "/qa" +
                                "/" +
                                itme?.contentDiags[0]?.diagId
                            );
                          }, 200);
                        }}
                      >
                        <div className={styles.consultationListTop}>
                          <div
                            className={styles.consultationListTopText}
                            data-a-href={"/qa/" + itme?.contentDiags[0]?.diagId}
                          >
                            {itme?.contentName}
                          </div>
                          <div className={styles.consultationListTopInfo}>
                            <span
                              data-a-href={"/qa/" + itme?.contentDiags[0]?.diagId}
                            >
                              点击查看
                            </span>
                            <img src={icon_right} alt="" />
                          </div>
                        </div>
                        <div className={styles.consultationListBon}>
                          <div className={styles.consultationListBonLeft}>
                            <div className={styles.consultationListBonLeftText1}>
                              <h3>总交流次数</h3>
                              <h5>
                                {itme?.contentDiags[0]?.doctorExchangeCount +
                                  itme?.contentDiags[0]?.patientExchangeCount ||
                                  0}
                              </h5>
                            </div>
                            <div className={styles.consultationListBonLeftLine} />
                            <div className={styles.consultationListBonLeftText2}>
                              <h3>医生回复次数</h3>
                              <h5>
                                {itme?.contentDiags[0]?.doctorExchangeCount || 0}
                              </h5>
                            </div>
                          </div>
                          <div className={styles.consultationListBonInfo}>
                            <span>患者：</span>
                            <h4>
                              {itme?.contentDiags[0]?.patientSex == 1
                                ? "男 "
                                : "女 "}
                              {itme?.contentDiags[0]?.patientAge || 0}
                            </h4>
                          </div>
                        </div>
                      </li>
                    );
                  })}
                </ul>
              </div>
            )}
            {/* 网站地图 */}
            {/* <div className={styles.sitemap}>
              <a href="https://www.jdh.com/sitemap.html" rel="nofollow">
                网站地图
              </a>
            </div> */}
          </div>
          {/* 右 */}
          {!loading ? (isZhangShi ?
            <div className={styles.right}>
              <div className={styles.rightFloat}>
                {departData?.docName && (
                  <div
                    className={styles.doctorInfo}
                    onClick={() => {
                      if (paragraphId) {
                        (window as any).log(
                          "HealthSEO_Exchange",
                          "Doctor",
                          JSON.stringify({
                            jsonParam: { id: params.id, doctorid: paragraphId },
                          })
                        );
                        setTimeout(() => {
                          onClickOpen(
                            window.location.origin + "/doctor/" + paragraphId
                          );
                        }, 200);
                      }
                    }}
                  >
                    <div className={styles.doctorInfoTit}>接诊医生</div>
                    <div className={styles.doctorInfoImg}>
                      <img
                        src={
                          "https://image.healthjd.com/nethpim/" +
                          departData?.doctorHeadImg
                        }
                        // alt={departData?.docName}
                        alt=""
                      />
                      <div className={styles.doctorInfoImgRight}>
                        <div className={styles.doctorInfoImgTop}>
                          {departData?.selfSupport && (
                            <img src={selfSupport} alt="" />
                          )}
                          {departData?.operationalOpenRxStatus === 1 && (
                            <img src={Prescribible} alt="" />
                          )}
                          <a className={styles.doctorInfoImgTopName}
                          data-a-href = {
                            "/doctor/" + paragraphId
                          }
                          onClick={() => {
                            console.log('点击了name', '======>');
                            onClickOpen(
                              window.location.origin +
                                "/doctor/" +
                                paragraphId
                            );
                          }
                          }
                          >
                            {departData?.docName}
                          </a>
                          <span>{departData?.titleName}</span>
                          {/* <span>{departData?.departName}</span> */}
                        </div>
                        <div className={styles.doctorInfoImgBotton}>
                          {departData?.hospitalGrade === 3 && (
                            <img src={Triple} alt="" />
                          )}
                          <p>
                            <span
                              onClick={(e) => {
                                e.stopPropagation();
                                onClickOpen("/hospital/" + departData?.hospitalId);
                              }}
                              data-a-href={"/hospital/" + departData?.hospitalId}
                            >
                              {departData?.hospitalName}
                            </span>
                            {' '}
                            <span
                              onClick={(e) => {
                                e.stopPropagation();
                                onClickOpen(`/hospital/department/${departData?.hospitalId}-${departData?.secondDepartId}`)
                              }}
                              data-a-href={`/hospital/department/${departData?.hospitalId}-${departData?.secondDepartId}`}
                            >
                              {departData?.secondDepartName}
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className={styles.doctorInfoText}>
                      擅长: {departData?.docGoodAt || "无"}
                    </div>
                    <div className={styles.doctorInfoNum}>
                      <div className={styles.doctorInfoNum1}>
                        <h2>好评率</h2>
                        <h5>
                          {Math.floor(departData?.patientEvaluationRate * 100) || 0}%
                        </h5>
                      </div>
                      <div className={styles.doctorInfoLine}></div>
                      <div className={styles.doctorInfoNum2}>
                        <h2>在线问诊量</h2>
                        <h5>{departData?.receivePatientNum || 0}</h5>
                      </div>
                    </div>
                    <div className={styles.doctorInfoBut}>立即咨询</div>
                  </div>
                )}

                <div className={styles.overbookingCode}>
                  <QRCode
                    value={
                      paragraphId
                        ? qrCodeUrl
                        : ""
                    }
                    size={80}
                  />
                  <div>
                    <h3>扫码关注医生</h3>
                    <h6>关注{departData?.docName || ''}医生，方便随时提问</h6>
                  </div>
                </div>

              </div>
            </div>
            : (
              <div className={`${styles.right} ${!docNum || docNum == 0 ? styles.displayNone : ''}`}>
                <div className={styles.rightFloatDoctorList}>
                {floorInfos ? 
                  <TabDoctorList
                    dataChange={(data: any) => {
                      setDocNum(data?.list?.length);
                    }}
                    boxTitle="为您推荐"
                    boxDesc="根据您浏览的疾病问答，推荐以下专家"
                    api={floorInfos?.api || {}}
                    cfg={floorInfos?.cfg || {}}
                    otherParams={{ diagId: params.id, pageSize: 5 }}
                    CustomMoreBtn={PopOvers}
                    moreFunc={() => {}}
                    doctorItemConfig={{
                      CustomServiceBtn: PopOver,
                      CustomServiceMoreBtn: PopOver,
                      CustomHosBtn: PopOver,
                      click_Card: () => {}, // 卡片整体点击
                      click_HeadImg: () => {}, // 头像点击
                      click_Adept: () => {}, // 擅长点击
                      click_Hos: () => {}, // 医院点击
                      click_Ask: () => {}, // 问医生点击
                      click_Service: () => {}, // 服务点击
                      click_Service_more: () => {}, // 更多服务点击
                      click_Service_custom: () => {}, // 服务点击自定义
                    }}
                  />
                : null}
                </div>
              </div>
            )) : null}
        </div>
      }
      <div className={styles.footerData} id="m_common_bottom">
        {/* <h2 className={styles.footerDataInvestor}>
          <a href="https://m.360buyimg.com/babel/jfs/t1/181014/6/22558/388522/62568785E608ef36a/d9ccabbcd5f95057.png!q20.webp">
            营业执照
          </a>
          <a href="https://ir.jdhealth.com/sc/index.php"> Investor Relations</a>
        </h2>
        <p>违法和不良信息举报电话：4006561155 消费者维权热线：4006067733</p>
        <p>Copyright © 2020 jdjiankang.com 版权所有</p>
        <h2 className={styles.footerDataImg}>
          <img src={beian} alt="" />
          <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=45050202000590">
            桂公网安备 45050202000590号
          </a>
          <a href="https://beian.miit.gov.cn/">桂ICP备202200128-5</a>
        </h2> */}
      </div>
      {/* 底部 */}
      {!loading && isZhangShi ?   
      <div className={styles.bottom}>
        <div className={styles.bottomDoctorInfo}>
          {departData && (
            <>
              <img
                src={
                  "https://image.healthjd.com/nethpim/" +
                  departData?.doctorHeadImg
                }
                // alt={departData?.docName}
                alt=""
              />
              <div className={styles.doctorInfoImgRight}>
                <div className={styles.doctorInfoImgTop}>
                  <div className={styles.doctorInfoImgTopName}>
                    {departData?.docName}
                  </div>
                  <span>{departData?.titleName}</span>
                  {/* <span>{departData?.departName}</span> */}
                  <p>已认证</p>
                </div>
                <div className={styles.doctorInfoImgBotton}>
                  {departData?.hospitalGrade === 3 && (
                    <img src={TripleHospital} alt="" />
                  )}
                  <p>
                    {departData?.hospitalName} {departData?.secondDepartName}
                  </p>
                </div>
              </div>
            </>
          )}
        </div>
        <div className={styles.bottomBtn}>
          <button
            className={styles.bottomBtn1}
            onClick={() => {
              (window as any).log(
                "HealthSEO_Exchange",
                "BottomDoctor",
                JSON.stringify({
                  jsonParam: { id: params.id, doctorid: paragraphId },
                })
              );
              setTimeout(() => {
                onClickOpen(window.location.origin + "/doctor/" + paragraphId);
              }, 200);
            }}
          >
            立即咨询
          </button>
          <Popover content={
            <Content
              qrCodeUrl={qrCodeUrl}
            />
          }>
            <button className={styles.bottomBtn2}>
              扫码关注医生，方便随时咨询
            </button>
          </Popover>
        </div>
      </div>
      : null}
    </div>
  );
};

export default ConsultationRecord;
